import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

/**
 * Componente para mostrar los detalles de una empresa
 * Se utiliza dentro del modal de visualización
 */
function DetallesEmpresa({ empresa }) {
  if (!empresa) {
    return (
      <MDBox p={3}>
        <MDTypography variant="body2" color="text">
          No hay datos disponibles
        </MDTypography>
      </MDBox>
    );
  }

  const DetailField = ({ label, value }) => (
    <MDBox mb={2}>
      <MDTypography variant="caption" color="text" fontWeight="bold">
        {label}:
      </MDTypography>
      <MDTypography variant="body2" color="text">
        {value || "No especificado"}
      </MDTypography>
    </MDBox>
  );

  DetailField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
  };

  return (
    <MDBox p={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <MDTypography variant="h6" color="info" mb={2}>
            Información Básica
          </MDTypography>
          <Divider />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Nombre de la Empresa" value={empresa.nombre_empresa} />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="NIT" value={empresa.nit} />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Correo" value={empresa.correo} />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Teléfono" value={empresa.telefono} />
        </Grid>

        <Grid item xs={12}>
          <MDTypography variant="h6" color="info" mb={2} mt={2}>
            Ubicación
          </MDTypography>
          <Divider />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Dirección" value={empresa.direccion} />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Ciudad" value={empresa.ciudad} />
        </Grid>

        <Grid item xs={12}>
          <MDTypography variant="h6" color="info" mb={2} mt={2}>
            Información de Contacto
          </MDTypography>
          <Divider />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Persona de Contacto Principal" value={empresa.persona_contacto} />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField label="Cargo" value={empresa.cargo} />
        </Grid>

        <Grid item xs={12}>
          <MDTypography variant="h6" color="info" mb={2} mt={2}>
            Comentarios
          </MDTypography>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <DetailField label="Comentarios" value={empresa.comentarios} />
        </Grid>

        <Grid item xs={12}>
          <MDTypography variant="h6" color="info" mb={2} mt={2}>
            Información del Sistema
          </MDTypography>
          <Divider />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField 
            label="Fecha de Creación" 
            value={empresa.created_at ? new Date(empresa.created_at).toLocaleString('es-CO') : null} 
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <DetailField 
            label="Última Actualización" 
            value={empresa.updated_at ? new Date(empresa.updated_at).toLocaleString('es-CO') : null} 
          />
        </Grid>

        {empresa.id_empresa && (
          <Grid item xs={12}>
            <DetailField label="ID" value={empresa.id_empresa} />
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
}

DetallesEmpresa.propTypes = {
  empresa: PropTypes.shape({
    id_empresa: PropTypes.string,
    nombre_empresa: PropTypes.string,
    nit: PropTypes.string,
    correo: PropTypes.string,
    telefono: PropTypes.string,
    direccion: PropTypes.string,
    ciudad: PropTypes.string,
    persona_contacto: PropTypes.string,
    cargo: PropTypes.string,
    comentarios: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }),
};

export default DetallesEmpresa;